import React, { useState } from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { AgencyMappingTable } from "./view/AgencyMappingTable";

interface Props {}

export const AgencyMapping: React.FC<Props> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_configureagreement_agencymapping_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>{userPermissions.includes(viewPermission) && <AgencyMappingTable />}</>
  );
};

export default AgencyMapping;
